<div class="modal-body">
  <div class="row" >
    <div class="table-responsive">
      <table class="table table-hover compact cell-border nowrap stripe">
        <thead>
          <tr>
            <th>Agenda Number</th>
            <th>Agenda Title</th>
            <th>Attachment</th>
            <th style="text-align: center; min-width: 200px;">Voting</th>
          </tr>
        </thead>
        <tbody>
            <tr *ngIf="isAgendaObjectEmpty">
                <td colspan="6" class="text-center">
                    No Records Found.
                </td>
            </tr>
           
          <tr *ngFor="let agenda of agendaObject">
            
            <td *ngIf="agenda.isPublished" >{{agenda.AgendaNumber}}</td>
            <td *ngIf="agenda.isPublished" ><a id="pdfFileAgendaLink"  (click)="downloadDocumentFile(agenda.AgendaConvertedDocxToPdf.DocumentManagementID,'pdf')">{{agenda.AgendaTitle}}</a></td>
            <td *ngIf="agenda.AgendaGenerationPdf.length >= 1 && agenda.isPublished">               
                <span  title="View Attachment" (click)="initiateUploadAgendaPdf(agenda)" *ngIf=" agenda.AgendaGenerationPdf.length > 0">
                    <i class="fa fa-paperclip"  title="View" style="font-size: 28px;font-weight: normal;cursor: pointer;"></i>
                </span>                
            </td>
            
            <!-- Voting Section -->
            <td *ngIf="agenda.isPublished" style="text-align: center; vertical-align: middle;">
              <div class="agenda-voting-section">
                <!-- Loading State -->
                <div *ngIf="votingLoading[agenda._id]" class="text-center">
                  <i class="fa fa-spinner fa-spin"></i> Loading...
                </div>
                
                <!-- Error State -->
                <div *ngIf="votingError[agenda._id] && !votingLoading[agenda._id]" class="text-danger small">
                  {{votingError[agenda._id]}}
                </div>
                
                <!-- Voting UI -->
                <div *ngIf="!votingLoading[agenda._id] && !votingError[agenda._id]">
                  <!-- Vote Buttons -->
                  <div class="vote-buttons" style="margin-bottom: 8px;">
                    <button 
                      type="button" 
                      class="btn btn-sm"
                      [ngClass]="getUserVote(agenda._id)?.voteType === 'APPROVE' ? 'btn-success' : 'btn-outline-success'"
                      (click)="submitVote(agenda, 'APPROVE')"
                      [disabled]="!canCurrentUserVoteAgenda(agenda._id)"
                      title="Approve this agenda"
                      style="margin-right: 5px; min-width: 70px;">
                      <i class="fa fa-check"></i> 
                      <span *ngIf="getUserVote(agenda._id)?.voteType === 'APPROVE'">Approved</span>
                      <span *ngIf="getUserVote(agenda._id)?.voteType !== 'APPROVE'">Approve</span>
                    </button>
                    
                    <button 
                      type="button" 
                      class="btn btn-sm"
                      [ngClass]="getUserVote(agenda._id)?.voteType === 'REJECT' ? 'btn-danger' : 'btn-outline-danger'"
                      (click)="submitVote(agenda, 'REJECT')"
                      [disabled]="!canCurrentUserVoteAgenda(agenda._id)"
                      title="Reject this agenda"
                      style="min-width: 70px;">
                      <i class="fa fa-times"></i> 
                      <span *ngIf="getUserVote(agenda._id)?.voteType === 'REJECT'">Rejected</span>
                      <span *ngIf="getUserVote(agenda._id)?.voteType !== 'REJECT'">Reject</span>
                    </button>
                  </div>
                  
                  <!-- Vote Counts -->
                  <div class="vote-counts" style="font-size: 11px; color: #666;">
                    <span class="text-success" style="margin-right: 10px;" title="Approve votes">
                      <i class="fa fa-thumbs-up"></i> {{getVoteCounts(agenda._id).approveCount}}
                    </span>
                    <span class="text-danger" title="Reject votes">
                      <i class="fa fa-thumbs-down"></i> {{getVoteCounts(agenda._id).rejectCount}}
                    </span>
                    <span *ngIf="getVoteCounts(agenda._id).totalVotes > 0" style="margin-left: 5px; color: #999;">
                      ({{getVoteCounts(agenda._id).totalVotes}} total)
                    </span>
                  </div>
                  
                  <!-- Retract Button (only shown if user has voted) -->
                  <div *ngIf="hasUserVoted(agenda._id)" style="margin-top: 5px;">
                    <button 
                      type="button" 
                      class="btn btn-sm btn-link"
                      (click)="retractVote(agenda._id)"
                      [disabled]="!canCurrentUserVoteAgenda(agenda._id)"
                      style="font-size: 10px; padding: 2px 5px; text-decoration: underline;">
                      Retract Vote
                    </button>
                  </div>
                  <div *ngIf="!canCurrentUserVoteAgenda(agenda._id)" class="small text-warning mt-1">
                    Not eligible to vote.
                  </div>
                  <div *ngIf="isAdmin" style="margin-top: 4px;">
                    <button type="button" class="btn btn-sm btn-link p-0" (click)="openVoterEligibilityModal(agenda)">
                      Manage voters
                    </button>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<div class="modal fade" id="agendaVoteEligibilityModal" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-md" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Manage voting eligibility</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <i class="fa fa-times"></i>
        </button>
      </div>
      <div class="modal-body">
        <div class="small text-muted mb-2" *ngIf="selectedAgendaForEligibility">
          Agenda {{ selectedAgendaForEligibility?.AgendaNumber }} - {{ selectedAgendaForEligibility?.AgendaTitle }}
        </div>
        <div class="eligibility-list">
          <div *ngIf="meetingParticipants.length === 0" class="small text-muted">No meeting participants found.</div>
          <div *ngFor="let p of meetingParticipants" class="eligibility-row">
            <label class="mb-0 d-flex align-items-start">
              <input type="checkbox" class="mr-2 mt-1" [checked]="isAgendaParticipantEligible(p.userId)" (change)="toggleAgendaParticipantEligibility(p.userId)">
              <span>
                <span class="d-block font-weight-bold small">{{ p.userName }} <span class="text-muted">({{ p.participantType }})</span></span>
                <span class="small text-muted" *ngIf="p.userEmail">{{ p.userEmail }}</span>
              </span>
            </label>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-default btn-sm" data-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary btn-sm" (click)="saveAgendaEligibility()" [disabled]="eligibilitySaving">
          <i *ngIf="eligibilitySaving" class="fa fa-spinner fa-spin mr-1"></i>Save
        </button>
      </div>
    </div>
  </div>
</div>


  <!-- AgendaCompliance POPUP LIST -->
  <div class="modal fade " id="agendasCompliancePopUp" style="padding:0;overflow-y:hidden" tabindex="-1" role="dialog" aria-labelledby="" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document" style="margin: 0;">
          <div class="modal-content">
              <div class="modal-header">
                  <h5 class="modal-title" id="agendasCompliancePopUpLabel">
                     Agenda Compliances</h5>
                  <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                      <i class="fa fa-times"></i>
                  </button>
              </div>
              <div class="modal-body">
                  <div class="datatable-card-block">
                      <div class="row">
                          <div class="col-md-12">
                              <div class="margin-bottom-50">
                                  <div class="table-responsive">
                                      <table datatable [dtOptions]="dtOptionsOfAgendaCompliancePopUp" [dtTrigger]="dtTriggerAgendaCompliancePopUp" class="table table-hover compact cell-border nowrap stripe"
                                          id="agendaCompliancePopUpTable" style="cursor: pointer;width:100%">
                                          <thead>
                                              <tr>
                                                  <th>Task Name</th>
                                                  <th>Task Description</th>
                                                  <th>Global/Company Specific</th>
                                                  <th>Group Name</th>
                                              </tr>
                                          </thead>
                                          <tbody>
                                              <tr *ngFor="let agendaCompliance of agendaCompliances">
                                                  <td style="white-space: normal;">{{agendaCompliance.TaskName}}</td>
                                                  <td style="white-space: normal;">{{agendaCompliance.TaskDescription}}</td>
                                                  <td>
                                                      <span *ngIf="agendaCompliance.IsGlobal">Global</span>
                                                      <span *ngIf="!agendaCompliance.IsGlobal">Company Specific</span>
                                                  </td>
                                                  <td>{{agendaCompliance.GroupName}}</td>
                                              </tr>
                                          </tbody>
                                      </table>

                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>

              <div class="modal-footer">
                  <button type="button" class="btn btn-sm" data-dismiss="modal">
                      <i class="fa fa-times"></i>Close
                  </button>
              </div>
          </div>
      </div>
  </div>
  <div class="modal fade modal-size-medium" id="agendaPdfUploadDialog" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false"
                aria-labelledby="" aria-hidden="true">
  <div class="modal-dialog" role="document">
      <div class="modal-content">
          <div class="modal-header modHeadCls">   
              <div id="AgendaNum" class="AgnCls"></div>   
              <button type="button" class="close" data-dismiss="modal" aria-label="Close" style="width: 36px !important;line-height: 20px !important;">
                  <i class="fa fa-times"></i>
              </button>              
          </div>  
          <div class="modal-body">
              <div class="col-md-12">
                  <div class="row collapse1"> 
                     <div *ngFor="let agenda of AgendaFile; let count=index" class="AgnBlock">
                       <div style="float: left;font-weight:bold;width: 85% !important;" tabindex="1">
                        {{agenda.PdfName}}                        
                       </div>
                       <div style="float: right;padding-left: 10px;width: 15% !important;">
                        <button type="button" class="btn-sm btn btn-warning" data-dismiss="modal" (click)="downloadDocumentFile(agenda.DocumentManagementID,agenda.FileType)" style="margin-top:0px !important;">
                          <span title="View" *ngIf="agenda.FileType == 'PDF' || agenda.FileType == 'pdf' " class="fa fa-eye"></span>
                          <span title="Download" *ngIf="agenda.FileType != 'PDF' && agenda.FileType != 'pdf' " class="fa fa-download"></span>
                         </button>  
                       </div>                      
                     </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</div>
